module.exports = __webpack_public_path__ + "img/delImg.9c697e3a.png";